<template>
  <div class="wrap">
    <div class="search-page-wrap">
      <div class="data-table-title">
        <div>ダッシュボード</div>
      </div>
      <div class="dashboard-wrap">
        <div class="dashboard-notification">
          <div class="wrap-title">お知らせ</div>
          <div class="dashboard-divider"></div>
          <div class="dashboard-notification-area">
            <div class="dashboard-notification-content" v-for="(notification, index) in notification" :key="notification.id">
              <div class="dashboard-notification-date">{{ notification.date }}</div>
              <div class="dashboard-notification-title" :class="notification.detail ? 'pointer' : ''" @click="notification.detail ? openDialog(notification) : ''">
                <span class="dashboard-notification-new" v-if="index == 0">NEW</span>
                {{ notification.title }}
              </div>
            </div>
          </div>
        </div>
        <notificationDialog :dialog_on.sync="dialog_on" :notification="target" />

        <div class="dashboard-photo">
          <div class="dashboard-photo-title"><font-awesome-icon icon="fire-alt" style="margin-right:5px" />注目のインフルエンサー</div>
          <el-carousel :interval="2000" arrow="hover" type="card" height="280px" indicator-position="none" v-loading="loading">
            <div v-for="influencer in influencer_data.influencer" :key="influencer.id" class="dashboard-influencer-wrap">
              <el-carousel-item class="dashboard-influencer" v-if="influencer.category_post != ''">
                <el-image :src="s3BaseUrl + '/postdata/' + influencer.category_post[0] + '_m.jpg'">
                  <div slot="error">
                    <el-image :src="s3BaseUrl + '/postdata/' + influencer.category_post[1] + '_m.jpg'">
                      <div slot="error"></div>
                    </el-image>
                  </div>
                </el-image>
                <div class="dashboard-influencer-profile">
                  <div class="dashboard-influencer-profile-imgarea pointer">
                    <router-link :to="{ name: 'influencerDetail', params: { account_name: influencer.account_name } }">
                      <el-image :src="influencer.profile_picture_url">
                        <div slot="error">
                          <img :src="s3BaseUrl + '/userdata/img_error_user.png'" alt="" />
                        </div>
                      </el-image>
                    </router-link>
                  </div>
                  <div class="dashboard-influencer-profile-profilearea">
                    <router-link
                      :to="{
                        name: 'influencerDetail',
                        params: {
                          account_name: influencer.account_name,
                          child: false,
                          default_search: false,
                        },
                      }"
                    >
                      <div class="dashboard-influencer-profile-profilearea-name pointer">{{ influencer.account_name }}</div>
                    </router-link>
                    <div class="dashboard-influencer-profile-profilearea-num">
                      フォロワー数: {{ influencer.followers }}人
                      <el-divider direction="vertical"></el-divider>
                      EGR: {{ influencer.average_engagement_rate }}%
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </div>
          </el-carousel>
        </div>
      </div>
      <div class="dashboard-subtitle">いろんな機能を使ってみましょう</div>
      <div class="dashboard-function">
        
        <!-- インフルエンサー検索 -->
        <el-tooltip placement="top" :disabled="search_enabled">
          <div class="activate-popover" slot="content">
            <div class="pointer" @click="toSetting">アップグレード</div>
            でご利用いただけます
          </div>
          <div class="dashboard-function-card pointer" @click="search_enabled ? changeOpeneds('2') : ''">
            <div class="dashboard-function-card-imgarea">
              <img src="../assets/search_image.png" alt />
            </div>
            <div class="dashboard-function-card-content">
              <div class="dashboard-function-card-title">インフルエンサー検索</div>
              <div>簡単にインフルエンサーが見つけられます</div>
            </div>
          </div>
        </el-tooltip>
      
        <!-- インフルエンサーリスト -->
        <el-tooltip placement="top" :disabled="view_influencer_list_enabled">
          <div class="activate-popover" slot="content">
            <div class="pointer" @click="toSetting">アップグレード</div>
            でご利用いただけます
          </div>
          <router-link to="/list" v-if="view_influencer_list_enabled">
            <div class="dashboard-function-card manage pointer" @click="view_influencer_list_enabled ? changeActive('list') : ''">
              <div class="dashboard-function-card-imgarea">
                <img src="../assets/list_image.png" alt />
              </div>
              <div class="dashboard-function-card-content">
                <div class="dashboard-function-card-title">インフルエンサーリスト</div>
                <div>リストの作成・管理ができます</div>
              </div>
            </div>
          </router-link>
          <router-link to="" v-else>
            <div class="dashboard-function-card manage pointer" @click="''">
              <div class="dashboard-function-card-imgarea">
                <img src="../assets/list_image.png" alt />
              </div>
              <div class="dashboard-function-card-content">
                <div class="dashboard-function-card-title">インフルエンサーリスト</div>
                <div>リストの作成・管理ができます</div>
              </div>
            </div>
          </router-link>
        </el-tooltip>
        
        <!-- クエリ英ティブ検索 -->
        <el-tooltip placement="top" :disabled="search_post_enabled">
          <div class="activate-popover" slot="content">
            <div class="pointer" @click="toSetting">アップグレード</div>
            でご利用いただけます
          </div>
          <div class="dashboard-function-card post_search pointer" @click="search_post_enabled ? changeOpeneds('3') : ''" aria-disabled="true">
            <div class="dashboard-function-card-imgarea">
              <img src="../assets/post_image.png" alt />
            </div>
            <div class="dashboard-function-card-content">
              <div class="dashboard-function-card-title">クリエイティブ検索</div>
              <div>より細かくクリエイティブの検索ができます</div>
            </div>
          </div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import notificationDialog from "./notification_dialog";
import { runCampaignGate } from '@/utils/campaignGate';
const root = process.env.VUE_APP_API;
const popularityAPI = root + "/api/dashboard/popularity";
const notificationAPI = root + "/api/dashboard/notification";

export default {
  name: "Dashboard",
  components: {
    notificationDialog,
  },
  data() {
    return {
      loading: false,
      useremail: firebase.auth().currentUser.email,
      post: [],
      influencer_data: [],
      notification: [],
      target: [],
      dialog_on: false,
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    view_influencer_list_enabled() {
      return !!this.$store.state.service_plan.view_influencer_list_enabled;
    },
    search_post_enabled() {
      return !!this.$store.state.service_plan.search_post_enabled;
    },
    search_enabled() {
      // 解約の場合はアップグレード手続きを表示するようにfalseを返す
      if (this.$store.state.activate === 1) return false;

      return !!(this.$store.state.service_plan.search_influencer_instagram_enabled ||
          this.$store.state.service_plan.search_influencer_youtube_enabled ||
          this.$store.state.service_plan.search_influencer_tiktok_enabled ||
          this.$store.state.service_plan.search_influencer_x_enabled);
    }
  },
  async mounted() {
    this.$store.dispatch("changeActive", "dashboard");

    // ダッシュボード入場時にキャンペーンモーダル表示（閉じたら約6か月抑制）
    try {
      await runCampaignGate('intro_slide_announce');
    } catch (e) {/* no-op: モーダル取得に失敗してもロード処理へ */}
    this.load();
  },
  methods: {
    signOut: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push("/login");
        });
    },
    load() {
      this.loading = true;
      this.axios.get(popularityAPI).then((response) => {
        this.influencer_data = response.data;
        this.loading = false;
      });
      this.axios.get(notificationAPI).then((response) => {
        this.notification = response.data.notification;
      });
    },
    changeActive(value) {
      this.$store.dispatch("changeActive", value);
      if (value != "i_search") {
        this.$store.dispatch("changeOpeneds", []);
      }
    },
    changeOpeneds(value) {
      this.$store.dispatch("changeOpeneds", [value]);
    },
    openDialog(notification) {
      this.target = notification;
      this.dialog_on = true;
    },
    toSetting() {
      this.$router.push("/setting");
    },
  },
};
</script>
